var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAutoRenewSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3707_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.99999V8.49166C10 8.86666 10.45 9.04999 10.7083 8.78332L13.0333 6.45832C13.2 6.29166 13.2 6.03332 13.0333 5.86666L10.7083 3.54166C10.45 3.28332 10 3.46666 10 3.84166V5.33332C6.31668 5.33332 3.33334 8.31666 3.33334 12C3.33334 12.8667 3.50001 13.7 3.80834 14.4583C4.03334 15.0167 4.75001 15.1667 5.17501 14.7417C5.40001 14.5167 5.49168 14.175 5.36668 13.875C5.12501 13.3 5.00001 12.6583 5.00001 12C5.00001 9.24166 7.24168 6.99999 10 6.99999ZM14.825 9.25832C14.6 9.48332 14.5083 9.83332 14.6333 10.125C14.8667 10.7083 15 11.3417 15 12C15 14.7583 12.7583 17 10 17V15.5083C10 15.1333 9.55001 14.95 9.29168 15.2167L6.96668 17.5417C6.80001 17.7083 6.80001 17.9667 6.96668 18.1333L9.29168 20.4583C9.55001 20.7167 10 20.5333 10 20.1667V18.6667C13.6833 18.6667 16.6667 15.6833 16.6667 12C16.6667 11.1333 16.5 10.3 16.1917 9.54166C15.9667 8.98332 15.25 8.83332 14.825 9.25832Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3707_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoRenewSign);
export default __webpack_public_path__ + "static/media/IconAutoRenewSign.2700d87c90bfe72e66aa3d24193e5eea.svg";
export { ForwardRef as ReactComponent };